import { render, staticRenderFns } from "./pdiComponent.vue?vue&type=template&id=42d138ba&scoped=true&"
import script from "./pdiComponent.vue?vue&type=script&lang=js&"
export * from "./pdiComponent.vue?vue&type=script&lang=js&"
import style0 from "./pdiComponent.vue?vue&type=style&index=0&id=42d138ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d138ba",
  null
  
)

export default component.exports